import {Component, Input, OnInit} from '@angular/core';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-review-claims-filter',
  templateUrl: './review-claims-filter.component.html',
  styleUrls: ['./review-claims-filter.component.scss']
})
export class ReviewClaimsFilterComponent extends FilterAbstractModel implements OnInit {

  reviewClaim: number;

  @Input() reviewSelected: number;

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.reviewSelected) {
      this.reviewClaim = this.reviewSelected;
    }
  }

  reset() {
    this.reviewClaim = null;
  }

}
